import { render, staticRenderFns } from "./c-reais.vue?vue&type=template&id=14d3c664&scoped=true"
import script from "./c-reais.vue?vue&type=script&lang=js"
export * from "./c-reais.vue?vue&type=script&lang=js"
import style0 from "./c-reais.vue?vue&type=style&index=0&id=14d3c664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d3c664",
  null
  
)

export default component.exports